<template>
  <div>
    <vxe-toolbar size="mini" v-if="!isHiddenBtn">
      <template v-slot:buttons>
        <template>
          <el-button
            type="primary"
            size="small"
            class="vxe-btn-primary"
            @click="introductionFeeHandler"
            >引入费用</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRules"
      :edit-config="{}"
      :valid-config="{ autoPos: true, message: 'inline' }"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
    </vxe-grid>
    <!-- 引入费用组件 -->
    <IntroductionCostDialog ref="introductionCostDialogRef" @confirmHandler="confirmHandler" />
  </div>
</template>

<script>
  import { tableColumn } from './index.js';
  import IntroductionCostDialog from './../IntroductionCostDialog/index.vue';
  export default {
    name: 'SettleAccountsDetailTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
      // 基础表单数据
      baseFormData: {
        type: Object,
        default: () => {},
      },
      // 当前行选中的数据
      currentSettleAccountRowData: {
        type: Object,
        default: () => {},
      },
      isCreate: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        tableData: [],
        selectionList: [],
        isHiddenBtn: false,
        tableRules: {},
        ids: [], // 被删除的数据id集合
      };
    },
    computed: {
      tableColumnsList() {
        return tableColumn(this);
      },
    },
    mounted() {},
    methods: {
      handleSelectionChange(row) {
        this.selectionList = row.selection;
      },
      // 引入费用
      async introductionFeeHandler() {
        const { currencyCode, currencyName, exchangeRate, contractNo } = this.baseFormData;
        const { supplierNo, supplierName, productCode, productName } =
          this.currentSettleAccountRowData;
        if (!currencyCode || !currencyName || !exchangeRate) {
          this.$message.error('请补充表单数据');
          return;
        }

        const data = {
          contractNo: contractNo,
          supplierNo: supplierNo,
          supplierName: supplierName,
          productCode: productCode,
          productName: productName,
        };
        this.$refs.introductionCostDialogRef.openModal(data, this.tableData);
      },
      // 确认引入费用
      confirmHandler(val) {
        console.log('引入费用');
        // 插入到行明细表中
        this.tableData = [...this.tableData, ...val];
        this.tableData = this.tableData.map((item) => {
          return {
            ...item,
            createMethod:
              item.createMethod == '01' || item.createMethod == '系统' ? '系统' : '手动',
          };
        });
        // 抛出当前表格数据
        this.$emit('confirmChooseDetailHandler', this.tableData);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
        this.$emit('confirmChooseDetailHandler', this.tableData);
      },
      // 获取表格数据
      getValidateTableData() {
        return new Promise((resolve) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          $table.validate(() => {
            const currentStatus = this.$route.query.status;
            const formTableData = tableData.map((item) => {
              return {
                ...item,
                departmentCode: this.userInfo.departmentCode,
                departmentName: this.userInfo.departmentName,
                companyCode: this.userInfo.companyCode,
                companyName: this.userInfo.companyName,
                // 特殊处理id
                id:
                  ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                    ? ''
                    : item?.id,
              };
            });
            resolve({ tableData: formTableData, deleteStorageLineIds: this.ids });
          });
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
    },
    watch: {
      isCreate: {
        handler(val) {
          this.isHiddenBtn = !val;
        },
        immediate: true,
      },
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          } else {
            this.fullTableData([]);
          }
        },
        immediate: true,
      },
    },
    components: {
      IntroductionCostDialog,
    },
  };
</script>

<style></style>
